import { saveAs } from 'file-saver';

import type { AxiosResponse } from 'axios';

enum ContentType {
  XLS = 'application/xls',
  ZIP = 'application/zip',
}

export const saveFileFromResponse = (response: AxiosResponse): void => {
  switch (response.headers['content-type']) {
    case ContentType.XLS:
    case ContentType.ZIP:
      {
        const element = document.createElement('a');
        element.href = response.data;
        document.body.appendChild(element);
        element.click();
      }
      break;
    default:
      saveAs(new Blob([response.data], { type: 'application/octet-stream' }), response.headers['x-filename']);
      break;
  }
};

export const saveFile = (blobPart: BlobPart, filename: string): void => {
  // { type: 'application/octet-stream' }
  saveAs(new Blob([blobPart], { type: 'application/octet-stream' }), filename);
};

export const downloadFileFromResponse = (response: AxiosResponse): void => {
  const contentDisposition = response.headers['content-disposition'];
  let filename = 'download.pdf';

  if (contentDisposition) {
    const filenameMatch = contentDisposition.match(/filename="(.+)"/);
    if (filenameMatch && filenameMatch[1]) {
      filename = filenameMatch[1];
    }
  }

  saveAs(new Blob([response.data], { type: 'application/octet-stream' }), filename);
};
